export default __webpack_public_path__ + "static/media/craft.315dc678.png";